import React from 'react';
import { motion } from 'framer-motion';
const treatments = [{
  title: 'Chemical Peel',
  desc: 'Smooth texture, fade discoloration, and refresh tone with a customized peel.',
  img: 'https://cdn.magicpatterns.com/uploads/gXmtEuimYtf8U6nmDud7Q8/Chemical_Peel.png'
}, {
  title: 'Facial Balancing w/ Filler',
  desc: 'Subtle contouring and proportion through expert filler placement.',
  img: 'https://cdn.magicpatterns.com/uploads/unEyJLRNt6PCPphSL6zQdG/Facial_Balancing_W__Filler.png'
}, {
  title: 'IPL Photofacial',
  desc: 'Target sun damage, redness, and pigmentation for a clearer complexion.',
  img: 'https://cdn.magicpatterns.com/uploads/rLzkB89XkbCp7x9NZa9x1r/IPL.jpg'
}];
export const TreatmentGallery = () => {
  return <section className="w-full bg-be-navy" data-id="element-199">
      {/* Editorial 3-up grayscale image strip */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-0" data-id="element-200">
        {treatments.map((t, i) => <motion.div key={i} initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1,
        duration: 0.6
      }} className="group relative overflow-hidden aspect-square sm:aspect-[3/4]" data-id="element-201">
            <img src={t.img} alt={t.title} className="w-full h-full object-cover grayscale brightness-90 transition-all duration-500 group-hover:grayscale-0 group-hover:brightness-100 group-hover:scale-105" data-id="element-202" />
            <div className="absolute inset-0 bg-gradient-to-t from-be-navy/80 via-be-navy/20 to-transparent" data-id="element-203" />
            <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8" data-id="element-204">
              <div className="h-px bg-be-pink w-10 mb-3" data-id="element-205" />
              <h3 className="text-white font-bold uppercase tracking-[0.15em] mb-2 text-sm sm:text-base" data-id="element-206">
                {t.title}
              </h3>
              <p className="text-white/70 text-xs sm:text-sm leading-relaxed" data-id="element-207">
                {t.desc}
              </p>
            </div>
          </motion.div>)}
      </div>

      {/* Section caption */}
      <div className="max-w-3xl mx-auto px-6 sm:px-10 py-12 text-center" data-id="element-208">
        <div className="h-px bg-be-pink w-10 mx-auto mb-5" data-id="element-209" />
        <h2 className="text-white font-serif italic text-3xl sm:text-4xl mb-3" data-id="element-210">
          What you can book with your credit
        </h2>
        <p className="text-white/60 text-sm sm:text-base leading-relaxed" data-id="element-211">
          Injectables, lasers, peels, facials, body — your $150 applies to any
          treatment your provider recommends.
        </p>
      </div>
    </section>;
};